import React, { useEffect, useMemo, useState } from "react";
import { Avatar } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import {
  contactInitial,
  getFaviconUrl,
  stringToColor,
} from "./contactDisplay";

export default function ContactAvatar({
  displayName,
  email,
  size = 38,
  isSelf = false,
  sx = {},
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const faviconUrl = useMemo(() => getFaviconUrl(email), [email]);
  const initial = contactInitial(displayName, email);
  const bg = stringToColor(displayName || email);
  const showLogo = Boolean(faviconUrl) && !imgFailed;

  useEffect(() => {
    setImgFailed(false);
  }, [faviconUrl, email]);

  if (isSelf) {
    return (
      <Avatar
        sx={{
          width: size,
          height: size,
          bgcolor: "rgba(0, 187, 205, 0.18)",
          color: "#008a98",
          ...sx,
        }}
      >
        <PersonOutlineIcon sx={{ fontSize: size * 0.52 }} />
      </Avatar>
    );
  }

  return (
    <Avatar
      src={showLogo ? faviconUrl : undefined}
      imgProps={{
        onError: () => setImgFailed(true),
        loading: "lazy",
        referrerPolicy: "no-referrer",
      }}
      sx={{
        width: size,
        height: size,
        bgcolor: showLogo ? "#ffffff" : bg,
        color: "#fff",
        fontWeight: 700,
        fontSize: size * 0.38,
        border: showLogo ? "1px solid rgba(148, 163, 184, 0.32)" : "none",
        "& img": showLogo
          ? {
              objectFit: "contain",
              width: "78%",
              height: "78%",
              margin: "auto",
            }
          : undefined,
        ...sx,
      }}
    >
      {showLogo ? null : initial}
    </Avatar>
  );
}
